import { render, staticRenderFns } from "./semesterProgress.vue?vue&type=template&id=049f930e&"
import script from "./semesterProgress.vue?vue&type=script&lang=js&"
export * from "./semesterProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports